import { IOfferForClient1 } from '../../repositories/chats/entities/for_client/OfferForClient1';
import { IOffer } from '../../repositories/chats/entities/get_my_offers_for_selection/Offer';

export const modifyOffer = (offer: IOffer): IOfferForClient1 => {
  // модифицирует формат оффера из селектору к виду оффера для чата

  const { photoUrl, ...restOfferData } = offer;

  return {
    ...restOfferData,
    photoUrls: photoUrl ? [photoUrl] : [],
  };
};
